<template>
<div>
  <v-row>
    <v-col
      v-if="showAdditional"
      cols="12"
      md="12"
      lg="12"
      class="pb-0"
    >
      <v-radio-group
        row
        v-model="ticket.voiceServicePresent"
      >
        <label class="mr-2">Is Exchange Based Voice Service Present?</label>
        <v-radio label="Yes" value="Yes"></v-radio>
        <v-radio label="No" value="No"></v-radio>
      </v-radio-group>
    </v-col>
    <v-col
      v-if="showAdditional"
      cols="12"
      md="12"
      lg="12"
      class="pb-0"
    >
      <v-text-field
        v-model="ticket.numberOfPhoneSockets"
        label="Number Of Phone Sockets"
        placeholder=" "
        outlined
        dense
        :readonly="false"
      ></v-text-field>
    </v-col>

    <v-col
      cols="12"
      md="12"
      lg="12"
      class="pb-0"
    >
      <v-text-field
        v-model="ticket.modemModel"
        label="CPE Modem Model"
        placeholder=" "
        outlined
        dense
        :readonly="false"
      ></v-text-field>
    </v-col>

    <v-col
      cols="12"
      md="12"
      lg="12"
      class="pb-0"
    >
      <v-text-field
        v-model="ticket.modemNumber"
        label="CPE Model Number"
        placeholder=" "
        outlined
        dense
        :readonly="false"
      ></v-text-field>
    </v-col>

    <v-col
      v-if="showAdditional"
      cols="12"
      md="12"
      lg="12"
      class="pb-0"
    >
      <v-radio-group
        row
        v-model="ticket.centralSplitterInstalled"
      >
        <label class="mr-2">Is Central Splitter Installed?</label>
        <v-radio label="Yes" value="Yes"></v-radio>
        <v-radio label="No" value="No"></v-radio>
      </v-radio-group>
    </v-col>

    <v-col
      v-if="showAdditional"
      cols="12"
      md="12"
      lg="12"
      class="pb-0"
    >
      <v-radio-group
        row
        v-model="ticket.alternateCableTested"
      >
        <label class="mr-2">Is Alternate Phone Cable Tested?</label>
        <v-radio label="Yes" value="Yes"></v-radio>
        <v-radio label="No" value="No"></v-radio>
      </v-radio-group>
    </v-col>

    <v-col
      cols="12"
      :md="6"
      class="pt-0 pb-1"
    >
      <ValidationProvider
        name="Power Status"
        :rules="'required'"
        v-slot="{ errors }"
      >
        <v-select
          :items="LedStatus"
          label="Power Status"
          name="Power Status"
          outlined
          placeholder="Please select Power Status"
          v-model="ticket.powerStatus"
        ></v-select>
      </ValidationProvider>
    </v-col>

    <v-col
      cols="12"
      :md="6"
      class="pt-0 pb-1"
    >
      <ValidationProvider
        name="Power Behaviour"
        :rules="'required'"
        v-slot="{ errors }"
      >
        <v-select
          :items="LedBehaviour"
          label="Power Behaviour"
          name="Power Behaviour"
          outlined
          placeholder="Please select Power Behaviour"
          v-model="ticket.powerBehaviour"
        ></v-select>
      </ValidationProvider>
    </v-col>

    <v-col
      cols="12"
      :md="6"
      class="pt-0 pb-1"
    >
      <ValidationProvider
        name="DSL/Sync Status"
        :rules="'required'"
        v-slot="{ errors }"
      >
        <v-select
          :items="LedStatus"
          label="DSL/Sync Status"
          name="DSL/Sync Status"
          outlined
          placeholder="Please select DSL/Sync Status"
          v-model="ticket.dslStatus"
        ></v-select>
      </ValidationProvider>
    </v-col>

    <v-col
      cols="12"
      :md="6"
      class="pt-0 pb-1"
    >
      <ValidationProvider
        name="DSL/Sync Behaviour"
        :rules="'required'"
        v-slot="{ errors }"
      >
        <v-select
          :items="LedBehaviour"
          label="DSL/Sync Behaviour"
          name="DSL/Sync Behaviour"
          outlined
          placeholder="Please select DSL/Sync Behaviour"
          v-model="ticket.dslBehaviour"
        ></v-select>
      </ValidationProvider>
    </v-col>


    <v-col
      cols="12"
      :md="6"
      class="pt-0 pb-1"
    >
      <ValidationProvider
        name="Internet Status"
        :rules="'required'"
        v-slot="{ errors }"
      >
        <v-select
          :items="LedStatus"
          label="Internet Status"
          name="Internet Status"
          outlined
          placeholder="Please select Internet Status"
          v-model="ticket.internetStatus"
        ></v-select>
      </ValidationProvider>
    </v-col>

    <v-col
      cols="12"
      :md="6"
      class="pt-0 pb-1"
    >
      <ValidationProvider
        name="Internet Behaviour"
        :rules="'required'"
        v-slot="{ errors }"
      >
        <v-select
          :items="LedBehaviour"
          label="Internet Behaviour"
          name="Internet Behaviour"
          outlined
          placeholder="Please select Internet Behaviour"
          v-model="ticket.internetBehaviour"
        ></v-select>
      </ValidationProvider>
    </v-col>
  </v-row>
</div>
</template>

<script>
export default {
  name: "nbn-check-list-details-fttn-fttb",
  props: {
    ticket: { type: Object },
  },
  data: () => ({
    LedStatus: [
      {text: "Green", value: "Green", disabled: false},
      {text: "Red", value: "Red", disabled: false},
      {text: "Off", value: "Off", disabled: false},
    ],
    LedBehaviour: [
      {text: "Flashing", value: "Flashing", disabled: false},
      {text: "Solid", value: "Solid", disabled: false},
    ]
  }),
  computed: {
    showAdditional() {
      let vm =this;
      return vm.ticket.category == 'Intermittent service/dropouts' || vm.ticket.category == 'No sync' || vm.ticket.category == 'Performance latency' || vm.ticket.category == 'VOIP fault';
    }
  }
}
</script>

<style scoped>

</style>
